import { Controller } from '@hotwired/stimulus'
import { createConsumer } from '@rails/actioncable'

export default class extends Controller {
  static values = {
    broadcastId: String,
    redirectUrl: String
  }

  get subscriptionParams() {
    const channel = 'V2::BatchActionsChannel'

    return {
      channel: channel,
      broadcast_id: this.broadcastIdValue
    }
  }

  connect() {
    this.suscribeToBulkDataRequestsChannel()
  }

  suscribeToBulkDataRequestsChannel() {
    const redirectUrl = this.redirectUrlValue

    createConsumer().subscriptions.create(this.subscriptionParams, {
      received(data) {
        this.handleChannelBroadcast(data, redirectUrl)
      },
      handleChannelBroadcast(data, redirectUrl) {
        const event = data.event

        switch (event) {
          case 'success':
            this.closeWaitDialog()
            this.redirectTo(redirectUrl)
            break
        }
      },
      closeWaitDialog() {
        const waitDialogContainer = document.getElementById('wait_dialog_container')
        waitDialogContainer.innerHTML = ''
      },
      redirectTo(url) {
        window.location.href = url
      }
    })
  }
}
